export const numericColors = ['#C32420', '#DB8918', '#EAC462', '#7BC39D', '#4BC3B4'];
export const cesColors = ['#C32420', '#DB8918', '#DB8918', '#EAC462', '#7BC39D', '#7BC39D', '#4BC3B4'];